var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackgroundDegradedGreen = function SvgBackgroundDegradedGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5657 4000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:.71;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-width:0px;}.cls-1,.cls-5{fill:#678E89;fill-rule:evenodd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:none;}.cls-4{fill:url(#linear-gradient-2);}.cls-7{clip-path:url(#clippath);}.cls-5{opacity:.79;}.cls-8{mask:url(#mask-1);}.cls-9{mask:url(#mask);}.cls-6{fill:url(#Degradado_sin_nombre_41);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 5657,
    height: 4000
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_41",
    x1: 560.18,
    y1: 4516.19,
    x2: 5247.84,
    y2: -683.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#406867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9976.62,
    y1: -3349.35,
    x2: -118.69,
    y2: 1748.28,
    gradientTransform: "translate(2369.29 -478.72) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -322.35,
    y: -523.43,
    width: 3412.36,
    height: 2873.37,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 187.57,
    y: -612.91,
    width: 2392.52,
    height: 3052.34,
    transform: "translate(250.11 2123.09) rotate(-80.28)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 13769.01,
    y1: -349.65,
    x2: 3673.7,
    y2: 4747.98,
    gradientTransform: "translate(9735.2 7803.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 2634.81,
    y: 2029,
    width: 3832.04,
    height: 3578.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3024.66,
    y: 2622,
    width: 3052.34,
    height: 2392.52,
    transform: "translate(-1285.15 2709.01) rotate(-29.24)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -12.42,
    width: 5681.83,
    height: 4000
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1267.42,2104.57c798.72,91.56,1538.47-453.61,1675.25-1252.36,51.85-302.77,9.86-600.02-104.94-862.18-6.62-15.11-13.48-30.12-20.57-44.99L354.32-476.7C140.71-262.67-11.05,16.8-65.88,337.02c-141.65,827.18,417.01,1613.07,1247.81,1755.33,28.55,4.89,57.06,8.96,85.5,12.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3892.4,2818.63c-678.7,430.94-911.24,1319.96-515.45,2027.11,150.03,268.05,369.55,472.82,623.65,604.52,14.65,7.59,29.42,14.95,44.28,22.05l2180.4-1220.36c31.56-300.74-26.12-613.48-184.8-896.98-409.88-732.32-1338.4-992.26-2073.91-580.59-25.28,14.15-50,28.91-74.17,44.25"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundDegradedGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "background-degraded-green.fafb38b1d0f3c03456c6e95b5292bd30.svg";